import { SET_USER_ERROR } from "../types";

const initialState = {};
const UserErrorReducer = (state = initialState, action) => {
    if (action.type === SET_USER_ERROR) return action.payload;
    return state;
}

export default UserErrorReducer;
